export const leadSource = [
  "Referral",
  "Internal Lead",
  "Social Media Lead",
  "Own Source",
  "CIMT",
  "Pitch",
  "Marketing",
  "Own Team",
  "Ticketing",
  "Social Media Camp",
  "social midea",
  "SIVAN APU",
  "PRA Lead",
  "Car Rental",
  "Travel Agent",
  "Social Media",
  "GoDeshi Event",
];
